import axios from 'axios'
import { CADASTRAR_ENCOMENDA_SICOOB } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

// cria a encomenda e já gera a cobrança PIX Sicoob, igual a pagarPedidoSicoob (passagem)
export default function cadastrarEncomendaSicoob (encomenda) {
  const url = `${URL}/encomendas/cadastrar/terminal-venda-sicoob`;
  return dispatch => axios.post(url, encomenda, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_ENCOMENDA_SICOOB,
        payload: response
      })
  );
}
